import { useTracking } from 'react-tracking';
import { SWS_ANALYSIS_MODEL } from '@/constants';
import { SnowflakeSection, BoldText } from './styled';
import { OverviewTranslation } from '@/pages/CompanyReport/components/OverviewSection/hooks/useOverviewTranslation';

const SnowflakeHelp = () => {
  const { trackEvent, Track } = useTracking();
  return (
    <Track>
      <SnowflakeSection>
        <p>
          <OverviewTranslation i18nKey="snowflake.about.paragraph1">
            <span>
              The Snowflake is a visual summary of our company analysis based on
              five fundamental areas:
            </span>
            <BoldText>Value, Future, Past, Health and Dividend.</BoldText>
            <span>
              It gives you an instant snapshot of company’s investment profile,
              helping you quickly decide if it is worth researching any further.
            </span>
          </OverviewTranslation>
        </p>
      </SnowflakeSection>
      <SnowflakeSection>
        <ul>
          <OverviewTranslation i18nKey="snowflake.about.list">
            <li>
              Each area has six metrics we measure a company against, which it
              either passes or fails.
            </li>
            <li>
              The colour of the Snowflake relates to its size. The more metrics
              a company passes, the larger and greener the Snowflake becomes.
              Inversely, the fewer metrics a company passes, the smaller and
              more red the Snowflake will be.
            </li>
            <li>
              The snowflake is not a buy or sell recommendation. It simply
              represents how attractive a company's fundamentals are. While its
              colour changes from red to green depending on how many checks the
              company passes, a low score in a particular assessment criteria
              should not necessarily exclude a stock from investment
              consideration.
            </li>
          </OverviewTranslation>
        </ul>
      </SnowflakeSection>
      <SnowflakeSection>
        <p>
          <OverviewTranslation i18nKey="snowflake.about.cta">
            <span>
              For a more in-depth explanation of the Snowflake, you can view our
            </span>
            <a
              href={`${SWS_ANALYSIS_MODEL}/MODEL.markdown#the-snowflake`}
              target="_blank"
              rel="noopener noreferrer nofollow"
              onClick={() =>
                trackEvent({
                  action: 'click',
                  modifier: 'link',
                  url: `${SWS_ANALYSIS_MODEL}/MODEL.markdown#the-snowflake`,
                })
              }
            >
              analysis model.
            </a>
          </OverviewTranslation>
        </p>
      </SnowflakeSection>
    </Track>
  );
};

export default SnowflakeHelp;
